<style lang="sass">
  $color-pack: false
  @import 'src/assets/style.scss'
</style>

<template>



  <v-app id="inspire" class="customTheme">
    
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
    <!-- <v-list-item>
      <v-list-item-content>
        <div class="ac"><img src="./assets/logo.png" alt="" style="height:86px; width:auto;"></div>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider> -->

      <v-list dense nav>
        <v-list-item link color="blue">
          <v-list-item-action>
            <v-icon color="primary">mdi-home-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          <router-link to="/">Home</router-link>
          </v-list-item-content>
        </v-list-item>
     

     


         <v-list-item link>
          <v-list-item-action>
            <v-icon color="primary">mdi-office-building</v-icon>
          </v-list-item-action>
          <v-list-item-content>
           <router-link to="/units">Units</router-link>
          </v-list-item-content>
        </v-list-item>

      
  


      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="white" class="primary--text" light>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="primary--text" />
      <v-toolbar-title>AXP Caliber</v-toolbar-title>
      <v-spacer></v-spacer>

      <div class="searchTop mr10px"><v-text-field single-line filled rounded dense hide-details label="Search" prepend-inner-icon="mdi-magnify"></v-text-field></div>

      <v-menu
        :close-on-content-click="false"
        offset-y
      >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="userInfoTop primary--text text-left" text small>
          <v-avatar>
            <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
          </v-avatar>
          <div class="detail ttn">
            <div class="name fw400 fs16px">Ron Warner</div>
            <div class="role fw400 grey--text">Admin</div>
          </div>
        </v-btn>
      </template>

      <v-card max-width="200" class="text-center">
        <v-card-text class="text-center">
          <v-avatar>
            <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
          </v-avatar>
          <div class="hdrUsername mt10px mb10px">Hello <span class="blue--text">Ron Warner</span></div>
          <v-btn color="error" depressed rounded small class="ttn">Logout</v-btn>
        </v-card-text>
      </v-card>
    </v-menu>

    </v-app-bar>

    <v-content>

       

     
      <v-container class="fill-height" fluid style="align-items: flex-start;">        
        <router-view></router-view>
      </v-container>

 <!--     <v-footer
        color="white"
        app
      >
      <div class="dib100 fs14px">
        <span class="gray--text fl">&copy; 2019 aXessPoint. All rights reserved.</span>
        <ul class="flinks m0px list-unstyled fr">
        <li><a href="#">Terms of Use</a></li>
        <li><a href="#">Privacy Policy</a></li>
        </ul>

      </div>
      </v-footer>-->
    </v-content>

  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
  }
</script>
